export default {
    state: {
        type: '',
        message: '',
        replace: {},
        timeoutRef: null,
        visible: false,
        title: '',
        callback: undefined,
        dismissBtn: true,
    },

    mutations: {
        addToast(state: any, options: any) {
            state.type = options.type;
            state.message = options.message;
            state.replace = options.replace || {};
            state.visible = true;
            state.title = options.title;
            state.callback = options.callback;
            state.dismissBtn = options.dismissBtn;
        },

        // tslint:disable-next-line:no-empty
        removeToast(state: any, callback: () => void = () => {}) {
            clearTimeout(state.timeoutRef);
            state.visible = false;
            callback();
        },
    },

    actions: {
        addToast({ state, commit }: any, options: any) {
            clearTimeout(state.timeoutRef);
            commit('addToast', options);
            state.timeoutRef = setTimeout(() => {
                commit('removeToast', options.callback);
            }, options.timeout ? options.timeout * 1000 : 3000);
        },
    },
};
